<div fxLayout="row" fxLayoutAlign="space-between start">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  @if (data.showDismissIcon) {
    <mat-icon style="padding-right: 10px; font-size: 30px; width: 30px; height: 30px; cursor: pointer" (click)="reference.close()">
      close
    </mat-icon>
  }
</div>
<div mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</div>
<div style="padding: 20px" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="flex-end" fxLayoutAlign.lt-md="center" fxLayoutGap="10px">
  @if (!data.hideNo) {
    <button mat-raised-button (click)="onChoice(false)" [color]="data.noColor">{{ data.no || 'No' }}</button>
  }
  <button mat-raised-button (click)="onChoice(true)" [color]="data.yesColor || data.color">{{ data.yes || 'Yes' }}</button>
</div>
